import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Displays a photo from Emergent object storage by fetching as blob.
 * Uses stored auth token via axios (Authorization header).
 */
export default function AuthImage({ path, alt = "", className = "", testId }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let revoke;
    let cancelled = false;
    if (!path) return;
    setErr(false);
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => {
        if (cancelled) return;
        const url = URL.createObjectURL(r.data);
        revoke = url;
        setSrc(url);
      })
      .catch(() => !cancelled && setErr(true));
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);

  if (err) {
    return (
      <div className={`bg-stone-100 flex items-center justify-center text-stone-400 text-xs ${className}`}>
        No image
      </div>
    );
  }
  if (!src) {
    return <div className={`bg-stone-100 animate-pulse ${className}`} />;
  }
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
}
